<template>
  <v-card outlined class="d-flex flex-column justify-center my-8 mx-8 pa-4">
    <p class="text--secondary">
      Đây là thao tác Bật/Tắt tin nhắn điểm danh tự động. Các thông tin về điểm danh của học sinh sẽ được gửi (hoặc
      không) tới ứng dụng Sổ liên lạc điện tử của phụ huynh học sinh.
    </p>

    <v-form ref="form" v-model="valid">
      <v-row>
        <v-col cols="4">
          <div>
            <p class="my-0">Trạng thái hiện tại</p>
            <span class="text-subtitle-2 font-weight-black">
              {{ currentStatusText }}
            </span>
          </div>
        </v-col>
        <v-col cols="2" class="d-flex justify-center align-start">
          <v-icon large>mdi-arrow-right</v-icon>
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="selectedStatus"
            :items="autoSendAttendanceMessageStatusesFilter"
            item-text="title"
            item-value="value"
            dense
            outlined
            clearable
            label="Trạng thái mới"
            class="required"
            :rules="rules"
          />
        </v-col>
      </v-row>
    </v-form>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer />
      <v-btn :disabled="!valid" @click="save" depressed color="primary" class="px-6 mt-4 white--text">Gửi</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'

const autoSendAttendanceMessageStatuses = [
  { value: true, title: 'Bật' },
  { value: false, title: 'Tắt' }
]

export default {
  components: {},
  data() {
    return {
      valid: false,
      selectedStatus: '',
      rules: [v => !!v || v === false || 'Trường này không được bỏ trống']
    }
  },
  computed: {
    ...mapState('app', ['settings']),
    autoSendAttendanceMessageStatusesFilter() {
      return autoSendAttendanceMessageStatuses.filter(s => s.value !== this.settings.autoSendAttendanceMessage)
    },
    currentStatusText() {
      return this.settings.autoSendAttendanceMessage ? 'Bật' : 'Tắt'
    }
  },
  methods: {
    ...mapActions('app', ['updateSchoolSettings']),
    async save() {
      this.$loading.active = true
      try {
        await this.updateSchoolSettings({ autoSendAttendanceMessage: this.selectedStatus })
        this.$alert.success('Cập nhật trạng thái điểm danh thành công')
      } catch (error) {
        this.$alert.error(error)
      }
      this.$loading.active = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
